import _ from 'lodash'
import HelperValidate from 'utils/helper-validate'
import HelperString from 'utils/helper-string'

const HelperTestID = {
	
	generate: ( testID, variable ) => {
		if( !HelperValidate.isValid( variable ) ) {
			variable = HelperString.random();
		}
		
		if( _.isArray( variable ) ) {
			variable = variable.join( '_' );
		}
		
		if( _.isString( variable ) === false ){
			variable = variable.toString();
		}
		
		variable = variable.replace( ' ', '_' );
		variable = variable.replace( '-', '_' );
		variable = variable.replace( ':', '_' );
		
		return `${testID}_${variable}`.toLowerCase();
	}
}

export default HelperTestID
